import { gql } from '@apollo/client';

export type {
  UserNotificationPreferences as IUserNotificationPreferences,
  UserNotificationPreferencesVariables as IUserNotificationPreferencesVariables,
} from './__generated__/UserNotificationPreferences';

export const USER_NOTIFICATION_PREFERENCES = gql`
  query UserNotificationPreferences($userId: String) {
    userNotificationPreferences(userId: $userId) {
      userId
      notificationPreferences {
        categoryKey
        enabled
      }
    }
  }
`;
